import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Logs = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const logsPerPage = 10;
  const { authState } = useContext(AuthContext);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/logs/all-logs`,
          {
            headers: {
              "x-auth-token": authState.token,
            },
          }
        );
        setLogs(response.data);
        setFilteredLogs(response.data);
        console.log("logs received from server;", response.data)
      } catch (error) {
        console.error("Error fetching logs:", error);
        // Handle error as per your application's error handling strategy
      }
    };

    fetchLogs();
  }, [authState.token]);

  useEffect(() => {
    if (selectedDate) {
      const filtered = logs.filter((log) => {
        const logDate = new Date(log.timestamp);
        return logDate.toDateString() === selectedDate.toDateString();
      });
      setFilteredLogs(filtered);
      setCurrentPage(1); // Reset to first page on date filter change
    } else {
      setFilteredLogs(logs);
    }
  }, [selectedDate, logs]);

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderDetails = (log) => {
    const details = log.body || log.params;
    return (
      <div className="flex flex-col">
        {Object.keys(details).map((key) => (
          <span key={key} className="text-sm">
            <strong>{key}:</strong> {details[key]}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="p-4 mt-16">
      <div className="text-center">
        <h2 className="text-4xl text-red-600 font-bold mb-4">Audit Logs</h2>
      </div>
      <div className="flex mb-4">
        <div className="mr-4">
          <label className="text-black font-bold">Filter by Date: </label>
          <ReactDatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="yyyy/MM/dd"
            isClearable
            className="text-center border py-2 rounded-md"
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-collapse rounded-lg overflow-hidden">
          <thead className="bg-gray-100 text-gray-800">
            <tr>
              <th className="py-2 px-3 text-left">Method</th>
              <th className="py-2 px-3 text-left">URL</th>
              <th className="py-2 px-3 text-left">Details</th>
              <th className="py-2 px-3 text-left">User</th>
              <th className="py-2 px-3 text-left">Timestamp</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {currentLogs.map((log) => (
              <tr key={log._id}>
                <td className="py-3 px-3">{log.method}</td>
                <td className="py-3 px-3">{log.url}</td>
                <td className="py-3 px-3">{renderDetails(log)}</td>
                <td className="py-3 px-3">
                  <div className="flex flex-col">
                    <span className="text-sm font-medium">
                      {log.user
                        ? `${log.user.firstname} ${log.user.lastname}`
                        : "Unknown User"}
                    </span>
                    <span className="text-xs text-gray-600">
                      {log.user ? log.user.email : ""}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-3">
                  {new Date(log.timestamp).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center mt-4">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-1 bg-black text-slate-300 rounded-md mr-1"
          >
            Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-1 bg-black text-slate-300 rounded-md ml-1"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logs;
